import { render, staticRenderFns } from "./ResponsesTab.vue?vue&type=template&id=79daaa3a&"
import script from "./ResponsesTab.vue?vue&type=script&lang=js&"
export * from "./ResponsesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports